
import { useToast } from "@/hooks/use-toast";
import { Creative, Location } from "../../types";

interface ContentStepValidationProps {
  campaignName: string;
  customMaterialLocations: Location[];
  locationCreatives: Record<string, Creative[]>;
}

export const useContentStepValidation = ({
  campaignName,
  customMaterialLocations,
  locationCreatives
}: ContentStepValidationProps) => {
  const { toast } = useToast();

  const validateStep = (): boolean => {
    // Validate campaign name
    if (!campaignName.trim()) {
      toast({
        title: "Campaign name is required",
        description: "Please provide a name for your campaign",
        variant: "destructive",
      });
      return false;
    }

    // Validate custom materials for special dimension locations
    if (customMaterialLocations.length > 0) {
      const missingCustomMaterials = customMaterialLocations.filter(location => {
        const locationMaterials = locationCreatives[location.name] || [];
        return locationMaterials.length === 0;
      });

      if (missingCustomMaterials.length > 0) {
        toast({
          title: "Custom materials required",
          description: `Please upload custom materials for locations: ${missingCustomMaterials.map(l => l.name).join(', ')}`,
          variant: "destructive",
        });
        return false;
      }
    }

    return true;
  };

  return { validateStep };
};
